<template>
    <div>
        <v-row>
            <v-col :lg="currentSelectedConfiguration ? 3 : 12" :md="currentSelectedConfiguration ? 4 : 12"
                :xl="currentSelectedConfiguration ? 2 : 12" class="border-right-divider" cols="12">

                <v-text-field
                    v-if="hideMobileListingForMobileIfListingItemSelectedForConfigurations() && hasConfigurations"
                    v-model="configurationFilterValue" :label="$gettext('Search configurations')"
                    append-icon="mdi-magnify" class="search-listing-autocomplete" clearable></v-text-field>

                <v-list
                    v-if="currentViewConfigurationCount() > 0 && hideMobileListingForMobileIfListingItemSelectedForConfigurations()"
                    class="v-list-wrapper groups-tab-list">

                    <!--                    color="primary"-->
                    <v-list-item-group v-model="currentSelectedConfiguration">
                        <draggable v-model="configurations" :options="{ disabled: $vuetify.breakpoint.mdAndDown }"
                            @end="syncConfigurations()">

                            <!-- :class is required because the v-list-item-group works toggle's it's active state and we do want to lose the focus. Otherwise on the second tap active class is lost -->
                            <v-list-item v-for="(configuration) in configurations"
                                v-show="configurationSelectedForMobile() && checkEachConfiguration(configuration.key)"
                                :class="{ 'v-item--active v-list-item--active v-list-item-active': !!(currentSelectedConfiguration && configuration.key && currentSelectedConfiguration === configuration.key) }"
                                :value="configuration.key" class="px-0" ripple
                                @click="selectConfiguration(configuration.key)">

                                <v-list-item-content>

                                    <v-list-item-title
                                        :class="{ 'add-border-list-on-small-devices': $vuetify.breakpoint.xsOnly }"
                                        class="text-left">

                                        <v-hover v-slot="{ hover }">
                                            <v-row>
                                                <v-col
                                                    :class="{ 'pl-4 pt-0 pb-0': $vuetify.breakpoint.xsOnly, 'py-0': $vuetify.breakpoint.smAndUp }"
                                                    class="body-2 text-truncate align-flex-start" cols="9" md="10"
                                                    sm="7">
                                                    <span class="pl-2 text-truncate" v-text="configuration.key"></span>
                                                </v-col>
                                                <v-col
                                                    :class="{ 'align-flex-end pt-0': $vuetify.breakpoint.xsOnly, 'align-flex-end': $vuetify.breakpoint.smAndUp }"
                                                    class="pr-4 ml-auto" cols="3" md="2" sm="5">

                                                    <v-menu>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon v-bind="attrs" v-on="on">
                                                                <v-icon v-text="icons.mdiDotsVertical"></v-icon>
                                                            </v-btn>
                                                        </template>

                                                        <v-list dense flat>
                                                            <!--                                                            @click="openAddEditConfigurationDialog('edit', configuration.key, currentSelectedConfiguration)"-->
                                                            <v-list-item :value="currentSelectedConfiguration"
                                                                @click="openAddEditDeviceMobileDialogV2('edit', configuration, currentSelectedConfiguration, currentSelectedConfigurationIndex)">
                                                                <v-list-item-title class="font-weight-regular">
                                                                    <v-icon :color="!isDark ? 'primary' : ''"
                                                                        class="mr-1" size="18"
                                                                        v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                    {{ $gettext('Edit') }}
                                                                </v-list-item-title>
                                                            </v-list-item>
                                                            <!--<v-list-item :value="currentSelectedConfiguration"
                                                                     @click="deleteConfiguration(configuration.key)">
                                                            <v-list-item-title class="font-weight-regular">
                                                                <v-icon :color="!isDark ? 'primary' : ''" class="mr-1"
                                                                        size="18"
                                                                        v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                {{ $gettext('Delete') }}
                                                            </v-list-item-title>
                                                        </v-list-item>-->
                                                        </v-list>
                                                    </v-menu>
                                                </v-col>
                                            </v-row>
                                        </v-hover>
                                    </v-list-item-title>
                                    <v-list-item-subtitle v-if="configuration.value.userInfo.mdmDeviceId"
                                        class="text-left pl-2 text-truncate caption grey--text font-weight-light"
                                        v-text="configuration.value.userInfo.mdmDeviceId">
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </draggable>
                    </v-list-item-group>
                </v-list>
                <v-row v-else-if="configurationFilterValue.length > 0" class="mx-1 mt-0 mb-3">
                    <v-col>
                        {{ $gettextInterpolate($gettext('No matching configurations found for your search: %{ configurationFilterValue }'), { configurationFilterValue }) }}
                    </v-col>
                </v-row>
                <v-row
                    v-else-if="(!currentSelectedConfiguration && $vuetify.breakpoint.mdAndDown) || ($vuetify.breakpoint.mdAndUp)"
                    class="mx-1 mt-0 mb-3">
                    <v-col>
                        {{ $gettext("You have not yet installed Lightphone on any of your phone; Once the application will be installed, the phone will appear here and you will be able to configure it.") }}
                    </v-col>
                </v-row>

                <v-spacer />
                <!--<v-divider v-if="$vuetify.breakpoint.mdAndUp" class="my-2"/>
                <v-row v-if="$vuetify.breakpoint.mdAndUp">
                    <v-col cols="12">
                        <v-btn class="width-100 mt-2" color="primary" @click="openAddEditDeviceMobileDialogV2('add')">
                            <v-icon class="mr-2" v-text="icons.mdiPlusCircleOutline"></v-icon>
                            {{ $gettext('Add Phone') }}
                        </v-btn>
                    </v-col>
                </v-row>-->

                <!--                    <v-divider v-if="$vuetify.breakpoint.mdAndUp"></v-divider>-->

                <!--otherwise during search the following gets to top-->
                <!--                    <v-spacer></v-spacer>-->

                <!--                    <v-bottom-navigation
                                        :value="1"
                                        color="primary"
                                        v-if="$vuetify.breakpoint.mdAndUp"
                                    >
                                        <v-btn @click="openAddEditConfigurationDialog('add', currentSelectedConfiguration)">
                                            <span v-text="$gettext('Add Configuration')"></span>
                                            <v-icon class="my-2 mr-1 "
                                                    v-text="icons.mdiFileDocumentPlusOutline"></v-icon>
                                        </v-btn>
                                    </v-bottom-navigation>-->
            </v-col>
            <v-col v-if="currentSelectedConfiguration" class="ml-3">

                <!-- This is useful when a user adds a phone but does not choose a phone model. The v-if condition here is very important otherwise, it will appear for even valid configurations -->
                <!--<configure-device
                    v-if="currentSelectedConfiguration && currentSelectedConfigurationIndex > -1 && Object.keys(configurations[currentSelectedConfigurationIndex].value.phone_model).length < 1"
                    :chosen-model="chosenModel"
                    @update-chosen-model="chosenModelValue => updateChosenModel(chosenModelValue)"
                    @update-folder-name="folderNameValue => updateFolderName(folderNameValue)"
                    @update-phone-type-index="phoneTypeIndexValue => updatePhoneTypeIndex(phoneTypeIndexValue)"
                    @update-selected-template="selectedTemplateValue => updateSelectedTemplate(selectedTemplateValue)"></configure-device>-->

                <!-- v-if="currentConfigurationHasPhoneModel" -->
                <v-row>

                    <v-col>
                        <v-row v-if="$vuetify.breakpoint.mdAndDown" class="text-left ml-4 mt-1">
                            <v-col>
                                <mobile-apps-path
                                    :device="configurations[currentSelectedConfigurationIndex]['value']['device']"
                                    :group="configurations[currentSelectedConfigurationIndex]['value']['user_group']"
                                    :user="configurations[currentSelectedConfigurationIndex]['value']['user']">
                                </mobile-apps-path>
                            </v-col>
                        </v-row>
                        <v-row class="mt-1">
                            <v-col
                                v-if="$vuetify.breakpoint.lgAndUp || (!chosenModel && modelsForSelectedConfiguration())"
                                :class="{ 'shrink': $vuetify.breakpoint.lgAndUp }">

                                <v-autocomplete v-if="!chosenModel && modelsForSelectedConfiguration()"
                                    v-model="chosenModel"
                                    :items="modelsForSelectedConfiguration() ? modelsForSelectedConfiguration() : []"
                                    :label="$gettext('Please select a phone model')"
                                    :placeholder="$gettext('Please select a phone model')" outlined>
                                </v-autocomplete>


                                <left-device v-if="$vuetify.breakpoint.mdAndUp"
                                    @update:appFilterText="(val) => this.appFilterText = val"></left-device>

                            </v-col>
                            <v-col :class="{ 'grow': $vuetify.breakpoint.lgAndUp }" order="1" order-lg="2">

                                <div v-if="$vuetify.breakpoint.lgAndUp">
                                    <mobile-apps-path
                                        :device="configurations[currentSelectedConfigurationIndex]['value']['device']"
                                        :group="configurations[currentSelectedConfigurationIndex]['value']['user_group']"
                                        :user="configurations[currentSelectedConfigurationIndex]['value']['user']"
                                        class="text-left">
                                    </mobile-apps-path>
                                    <!-- v-if="phoneTypeIndex > -1" -->

                                    <v-row class="mb-2">
                                        <v-col class="text-left" cols="8">

                                            <span class="hover-underline mr-1" v-if="!showAllowAppInstallationsOptions && !currentAppInstallationViaPlayStore" @click="setBlankAppInstallationViaPlayStore()">
                                                        {{ $gettext('Allow app installations temporarily') }}
                                                    </span>
                                                    <span v-if="!showAllowAppInstallationsOptions && currentAppInstallationViaPlayStore?.hasOwnProperty('minutesAllowed')">
                                                        {{ $gettext('You have allowed app installations via Google Play Store (and other stores) for a duration of ') }} {{ currentAppInstallationViaPlayStore?.minutesAllowed }} {{ $gettext('minutes') }}
                                                        <v-icon class="text-right mr-2" @click="setShowAllowAppInstallationsOptions(true)" v-text="icons.mdiPencilCircleOutline">
                                                        </v-icon>
                                                        <v-icon class="text-right mr-2" @click="deleteAppInstallationViaPlayStore()" v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                    </span>
                                                    <span v-if="showAllowAppInstallationsOptions && currentAppInstallationViaPlayStore?.hasOwnProperty('minutesAllowed')">
                                                        {{ $gettext('How long would you like to allow app installations via Google Play Store?') }}
                                                    </span>
                                            <v-tooltip bottom color="primary" v-if="!showAllowAppInstallationsOptions && !currentAppInstallationViaPlayStore?.hasOwnProperty('minutesAllowed')">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span class="cursor-pointer" icon v-bind="attrs" v-on="on" >
                                                            <v-icon class="my-2 mr-1" 
                                                                v-text="icons.mdiHeadQuestion"></v-icon>
                                                    </span>
                                                </template>

                                                <div class="white-background">
                                                    {{ $gettext('This allows the user to access the app store and install applications for a duration you specify.') }}
                                                </div>
                                            </v-tooltip>

                                            <v-row v-if="showAllowAppInstallationsOptions && currentAppInstallationViaPlayStore?.hasOwnProperty('minutesAllowed')" class="mt-2">
                                                <v-col>
                                                    <v-text-field
                                                        ref="minutesAllowedRef"
                                                        v-model="currentAppInstallationViaPlayStore.minutesAllowed"
                                                        :label="$gettext('Duration in minutes')"
                                                        :placeholder="$gettext('Duration in minutes')"
                                                        outlined
                                                        class="max-width-200"
                                                        type="number"
                                                        :rules="[
                                                            v => v >= 30 || $gettext('Minimum 30 minutes required'),
                                                            v => v <= 600 || $gettext('Maximum 600 minutes allowed')
                                                        ]"
                                                    ></v-text-field>
                                                    <v-btn
                                                        color="primary"
                                                        @click="setShowAllowAppInstallationsOptions(false)"
                                                        class="mr-2"
                                                        :disabled="!isMinutesAllowedValid"
                                                    >
                                                        {{ $gettext('Set') }}
                                                    </v-btn>
                                                    <v-btn
                                                        color="primary"
                                                        @click="deleteAppInstallationViaPlayStore()"
                                                        class="mr-2"
                                                    >
                                                        {{ $gettext('Delete') }}
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col class="text-right" cols="4">
                                            <v-btn 
                                                color="primary" 
                                                @click="refreshAppStore" 
                                                :title="$gettext('Refresh applications list')"
                                                elevation="2"
                                                class="refresh-apps-btn">
                                                <v-icon left v-text="icons.mdiRefresh"></v-icon>
                                                {{ $gettext('Refresh Apps') }}
                                            </v-btn>
                                        </v-col>
                                        
                                    </v-row>
                                    <app-store></app-store>

                                    <!--
                                    v-else
                                    <div
                                        v-text="$gettext('Sorry! Your saved configuration device does not match our devices library. Please consider deleting this configuration and creating a new configuration.')">
                                    </div>
                                    -->
                                </div>
                                <div v-else>

                                    <v-tabs v-model="phoneTab">
                                        <v-tab v-if="$vuetify.breakpoint.mdAndDown" :value="'device'"
                                            v-text="chosenModel"></v-tab>
                                        <!--                                        <v-tab :value="'users'" v-text="$gettext('Users')"></v-tab>-->
                                        <v-tab :value="'store'" v-text="$gettext('Apps Store')"></v-tab>
                                    </v-tabs>

                                    <v-tabs-items v-model="phoneTab">
                                        <v-tab-item v-if="$vuetify.breakpoint.mdAndDown" :key="'device'" class="mt-6">
                                            <div class="text-left subtitle-2 mb-3">
                                                {{ $gettext('Manage the apps for this device') }}
                                            </div>
                                            <left-device v-if="$vuetify.breakpoint.mdAndDown"
                                                @update:appFilterText="(val) => this.appFilterText = val"></left-device>
                                        </v-tab-item>
                                        <!--                                        <v-tab-item :key="'users'">-->


                                        <!--                                                    <div class="text-left">{{ currentSelectedConfiguration }}</div>-->
                                        <!--                                            <div class="text-left subtitle-2 mt-6 mb-3">
                                                                                        {{
                                                                                            $gettext('Please select the users for whom this configuration should apply')
                                                                                        }}
                                                                                    </div>-->
                                        <!--                                            <v-row>
                                                                                        <v-col>
                                                                                            <draggable group="addUser" v-model="usersForCurrentConfiguration"
                                                                                                       :options="{disabled : $vuetify.breakpoint.mdAndDown}">
                                                                                                <v-autocomplete
                                                                                                    auto-select-first
                                                                                                    v-model="usersForCurrentConfiguration"
                                                                                                    :items="consolidatedUsersAndSubUsers"
                                                                                                    :label="$gettext('Users')"
                                                                                                    multiple
                                                                                                    chips
                                                                                                    @change="updateSelectedUsersForConfiguration()"
                                                                                                    deletable-chips
                                                                                                    :append-outer-icon="icons.mdiOpenInNew"
                                                                                                    @click:append-outer="openAddUserToConfigurationDialog()"
                                                                                                    outlined
                                                                                                ></v-autocomplete>
                                                                                            </draggable>
                                                                                        </v-col>
                                                                                    </v-row>-->

                                        <!--                                        </v-tab-item>-->
                                        <v-tab-item :key="'store'">

                                            <div v-if="phoneTypeIndex > -1">
                                                <v-row align="center" justify="end" class="mb-3">
                                                    <v-spacer></v-spacer>
                                                    <v-btn 
                                                        color="primary" 
                                                        @click="refreshAppStore" 
                                                        :title="$gettext('Refresh applications list')"
                                                        elevation="2"
                                                        class="refresh-apps-btn">
                                                        <v-icon left v-text="icons.mdiRefresh"></v-icon>
                                                        {{ $gettext('Refresh Apps') }}
                                                    </v-btn>
                                                </v-row>
                                                <app-store></app-store>
                                            </div>
                                            <div v-else
                                                v-text="$gettext('Sorry! Your saved configuration device does not match our devices library. Please consider deleting this configuration and creating a new configuration.')">
                                            </div>

                                        </v-tab-item>
                                    </v-tabs-items>
                                </div>

                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="text-right">
            <v-col>
                <small>
                    {{ $gettext('Configurations:') }} {{ getConfigurationCountWithFilter() }}
                </small>
            </v-col>
        </v-row>

        <snackbar ref="snackbar" />

        <dialog-configuration-add-edit v-if="addEditConfigurationDialog" :params="addEditConfigurationParams"
            @selectTheConfigurationAdded="function (configurationAddedName) { selectConfiguration(configurationAddedName) }"></dialog-configuration-add-edit>
        <dialog-models-add v-if="addModelDialog" :params="addModelParams"
            @modelAddedSuccessfully="function () { loadAModelIfWeHaveIt() }"></dialog-models-add>

        <v-dialog v-model="addUserToConfigurationDialog" transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar :class="dialogHeadingClasses()" color="primary" dark>{{ $gettext('Manage User(s)') }}
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeAddUserToConfigurationDialog()">{{
                        icons.mdiClose
                        }}
                    </v-icon>
                </v-toolbar>
                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>

                        <v-row>
                            <v-col>
                                <div :class="{ 'text-h5': $vuetify.breakpoint.mdAndUp, 'text-h6': $vuetify.breakpoint.mdAndDown }"
                                    class="pb-3 secondary--text">
                                    {{ $gettext('All Users') }}
                                    <!--  The autocomplete loads but filter is yet to be done -->
                                    <!-- <v-autocomplete
                                        ref="userSearch"
                                        append-icon="mdi-magnify"
                                        v-model="userAutoCompleteFilterValue2"
                                        :items="prepareAnArrayForAutocompleteTopLevel(users)"
                                        label="Narrow down to a User"
                                        clearable
                                        autofocus
                                    ></v-autocomplete>-->
                                </div>
                                <v-divider />

                                <v-list
                                    :class="{ 'height-60-vh': $vuetify.breakpoint.mdAndUp, 'height-30-vh': $vuetify.breakpoint.mdAndDown }"
                                    class="overflow-x-auto">

                                    <v-list-group v-for="(category, categoryKey) in users" :key="categoryKey"
                                        class="user-listing" no-action>
                                        <template v-slot:activator>
                                            <v-list-item-content>
                                                <v-list-item-title class="text-h6"
                                                    v-text="category.key"></v-list-item-title>
                                            </v-list-item-content>
                                        </template>

                                        <v-list-item v-for="(user) in category.value"
                                            v-if="!userPrivateAttributes.includes(user.key)" :key="user.key"
                                            class="pl-4">
                                            <v-list-item-content class="py-2 mb-auto">
                                                <v-list-item-title class="user-cursor-pointer"
                                                    @click="insertUserToRule(user.key)">
                                                    <v-icon v-text="icons.mdiAccountCircle"></v-icon>
                                                    {{ user.key }}
                                                </v-list-item-title>
                                            </v-list-item-content>

                                            <v-list-item-group v-if="user.value.subusers?.length > 0">
                                                <v-list-item v-for="(subUser) in user.value.subusers" :key="subUser.key"
                                                    class="pl-4" dense>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="user-cursor-pointer"
                                                            @click="insertUserToRule(subUser.key)">
                                                            <v-icon class="mr-2"
                                                                v-text="icons.mdiAccountChildCircle"></v-icon>
                                                            <span class="subtitle-2" v-text="subUser.key"></span>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list-item-group>

                                        </v-list-item>


                                    </v-list-group>

                                </v-list>
                            </v-col>
                            <v-col :class="{ 'order-first': $vuetify.breakpoint.mdAndDown }">
                                <div :class="{ 'text-h5': $vuetify.breakpoint.mdAndUp, 'text-h6': $vuetify.breakpoint.mdAndDown }"
                                    class="pb-3 secondary--text">
                                    {{ $gettext('Chosen User(s)') }}
                                </div>
                                <v-divider />
                                <v-list
                                    :class="{ 'height-60-vh': $vuetify.breakpoint.mdAndUp, 'height-30-vh': $vuetify.breakpoint.mdAndDown }"
                                    class="overflow-x-auto">
                                    <v-list-item-group
                                        v-if="usersForCurrentConfiguration && usersForCurrentConfiguration.length > 0"
                                        class="chosen-user-delete-icon">
                                        <draggable v-model="usersForCurrentConfiguration"
                                            :options="{ disabled: $vuetify.breakpoint.mdAndDown }" group="addUser">
                                            <v-list-item v-for="(user, userKey) in usersForCurrentConfiguration"
                                                :key="userKey">
                                                <v-list-item-content class="py-2" v-text="user">
                                                </v-list-item-content>
                                                <v-list-item-icon>
                                                    <v-icon v-text="icons.mdiDeleteForever"
                                                        @click.native.stop="deleteUserForRule(user)"></v-icon>
                                                </v-list-item-icon>
                                            </v-list-item>
                                        </draggable>
                                    </v-list-item-group>
                                    <v-list-item-group v-else>
                                        <v-list-item>
                                            <v-list-item-content>
                                                {{ $gettext('No user chosen yet.') }}
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions fixed>
                    <span v-if="usersForCurrentConfiguration" class="text-subtitle-2 font-weight-light">
                        {{ $gettext('Chosen users:') }}
                        {{ usersForCurrentConfiguration.length }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native.stop="closeAddUserToConfigurationDialog()">
                        {{ $gettext('Close') }}
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <dialog-users-and-category-add-edit-device-mobile-v2 v-if="addEditDeviceMobileDialog"
            :params="addEditDeviceMobileDialogParams" @mobile-device-updated="handleMobileDeviceUpdate"
            @mobile-device-added-v2="handleMobileDeviceAddV2"
            @open-manage-apps-dialog="(params) => { openManageAppsDialog(params) }" />

    </div>
</template>

<script>


import axios from 'axios'
import MixinProfilesApplicationTab from '@/mixins/MixinProfilesApplicationTab'
import Snackbar from '@/components/Snackbar.vue'
import { mapWritableState } from 'pinia'
import { useUsersStore } from '@/stores/UsersStore'
import MixinIcon from '@/mixins/MixinIcon'
import AppIcon from '@/components/devices/AppIcon.vue'
import { usePhonesStore } from '@/stores/PhonesStore'
import draggable from 'vuedraggable'
import DialogAppsAddEdit from '@/components/dialogs/apps/DialogAppsAddEdit.vue'
import MixinDialog from '@/mixins/MixinDialog'
import DialogConfigurationAddEdit from '@/components/dialogs/apps/DialogConfigurationAddEdit.vue'
import MixinListing from '@/mixins/listing/MixinListing'
import { findIndex } from 'lodash'
import DialogModelsAdd from '@/components/dialogs/apps/DialogModelsAdd.vue'
import { usePhoneTypesStore } from '@/stores/PhoneTypesStore'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'
import { required } from 'vuelidate/lib/validators'
import MixinApps from '@/mixins/apps/MixinApps'
import { config } from '@vue/test-utils'
import DeviceSearchingText from "@/components/blocks/DeviceSearchingText.vue";
import DeviceNoAppsFound from "@/components/blocks/DeviceNoAppsFound.vue";
import LeftDevice from "@/components/devices/LeftDevice.vue";
import ConfigureDevice from "@/components/tabs/mobile/ConfigureDevice.vue";
import MixinMobileAppsStoreDevice from "@/mixins/mobile_apps/MixinMobileAppsStoreDevice";
import MixinMobileLeftStoreDevice from "@/mixins/mobile_apps/MixinMobileLeftStoreDevice";
import MixinConfiguration from "@/mixins/mobile_apps/MixinConfiguration";
import AppStore from "@/components/devices/AppStore.vue";
import MobileAppsPath from "@/components/devices/MobileAppsPath.vue";
import MixinDark from "@/mixins/database/MixinDark";
import MixinGenericComponent from "@/mixins/generic/MixinGenericComponent";
import constants from "@/assets/js/constants";
import DialogUsersAndCategoryAddEditDeviceMobileV2
    from "../dialogs/users_and_categories_tab/DialogUsersAndCategoryAddEditDeviceMobileV2.vue";
import { useConnectionsStore } from '@/stores/ConnectionsStore'
import { useLoginStore } from '@/stores/LoginStore'
import { useAppUsageRestrictionsStore } from '@/stores/AppUsageRestrictionsStore'
import MixinConfig from '../../mixins/database/MixinConfig'
import { eventBus } from '@/main'

export default {
    name: 'ProfileApplicationTab',
    mixins: [MixinProfilesApplicationTab, MixinIcon, MixinDialog, MixinListing, MixinSwalConfirmation, MixinApps, MixinMobileAppsStoreDevice, MixinMobileLeftStoreDevice, MixinConfiguration, MixinDark, MixinGenericComponent, MixinConfig],
    components: {
        DialogUsersAndCategoryAddEditDeviceMobileV2,
        MobileAppsPath,
        AppStore,
        ConfigureDevice,
        LeftDevice,
        DeviceNoAppsFound,
        DeviceSearchingText,
        DialogModelsAdd,
        DialogAppsAddEdit,
        AppIcon,
        Snackbar,
        draggable,
        DialogConfigurationAddEdit
    },
    data() {
        return {

            filteredCurrentApplications: [],

            phoneTab: 'store',

            appFilterText: '',

            usersForCurrentConfiguration: [],
            addUserToConfigurationDialog: false,
            filteredList: null,
            templateList: [],
            selectedTemplate: null,
            templateAppList: [],
            folderName: null,

            chosenModelAutocomplete: '',
            appMenu: '',

            // showAddApplications: false,

            addModelDialog: false,
            addModelParams: {},

            // currentSelectedConfiguration: '',
            // currentSelectedConfigurationIndex: -1,

            configurationFilterValue: '',

            rightClickContextMenu: [
                {
                    text: 'Add an Application',
                    value: 'add'
                }
            ],

            applicationTabField: '',
            chosenUser: '',
            chosenDevice: '',
            step: 1,

            /**
             * We are having this over here instead of in the child component because otherwise the earlier opened menus are kept open. We needed something that is not just common to all appIcons but dynamic as well. In the future, this should be improved, and simplified but for now this works, and we will circle back on this soon.
             */
            showMenu: { value: false, packageName: '' },
            x: 0,
            y: 0,

            addEditAppParams: {},
            addEditAppDialog: false,

            addEditConfigurationDialog: false,
            addEditConfigurationParams: {},

            addEditDeviceMobileDialog: false,
            addEditDeviceMobileDialogParams: {},
            editUserName: '',
            editUserNameCategory: '',
            editDeviceNameField: '',
            editDeviceCredentialsField: '',
            editPhoneModel: '',

            showAllowAppInstallationsOptions: false

        }
    },
    mounted() {

        let self = this

        // this.loadPageInformation()
        self.removeDuplicatePackagesForAllConfigurations()
        self.setHeightForListingBox();

        /**
         * This is useful when a user creates a mobile equipment from the users tab, where this tab was never loaded, where the chosenModel is not set, and hence, the loadAModelIfWeHaveIt() was not called. Hence, we are calling it here.
         */
        if (self.currentSelectedConfiguration && (!self.chosenModel)) {
            self.loadAModelIfWeHaveIt();
        }

        // Select first configuration as currentSelectedConfiguration
        if (self.configurations.length > 0 && !self.currentSelectedConfiguration) {
            self.currentSelectedConfiguration = self.configurations[0].key
            self.currentSelectedConfigurationIndex = self.configurations.findIndex(val => val.key === self.currentSelectedConfiguration)
        }

    },
    watch: {

        currentSelectedConfiguration(newValue, oldValue) {

            let self = this

            if (newValue && newValue.length) {

                self.usersForCurrentConfiguration = []

                self.currentSelectedConfigurationIndex = findIndex(self.configurations, val => val.key === self.currentSelectedConfiguration)
                self.chosenModel = ''
                self.chosenModelAutocomplete = ''
                self.appFilterText = ''
                /**
                 * When we right-click on an application, and remove application, it gets removed but for some other configuration with same or similar device, and having the same app, the right click context menu from the previous removal was still remaining open, hence, now when the configuration changes, we are resetting the showMenu value.
                 * @type {{packageName: boolean, value: boolean}}
                 */
                self.showMenu = { value: false, packageName: false };

                self.usersForCurrentConfiguration = self.configurations[self.currentSelectedConfigurationIndex]?.value?.users

                self.loadAModelIfWeHaveIt()
                self.$v.$reset()
                self.phoneTypeIndex = findIndex(self.phoneTypes, { key: self.chosenModel })

                self.nullTemplateFields()

                this.filteredCurrentApplications = this.getFilteredCurrentApplications()

            }

            if (oldValue && oldValue.length && !newValue?.length) {

                self.currentSelectedConfigurationIndex = findIndex(self.configurations, val => val.key === oldValue)    
                self.currentSelectedConfiguration = oldValue


            }

        },

        chosenUser(newValue) {
            if (newValue && newValue.length > 0 && this.step === 1) {
                this.step = 2
            }
        },
        chosenDevice(newValue) {
            if (newValue && newValue.length > 0 && this.step === 2) {
                this.step = 3
            }
        },
        configurations: {
            handler() {

                this.filteredCurrentApplications = this.getFilteredCurrentApplications()

            },
            deep: true
        },
        restrictions: {
            handler() {
                // Ensure minutesAllowed is always a number
                Object.keys(this.restrictions).forEach(mdmDeviceId => {
                    const restrictionData = this.restrictions[mdmDeviceId];
                    if (restrictionData?.appInstallationViaPlayStore?.minutesAllowed) {
                        const currentValue = restrictionData.appInstallationViaPlayStore.minutesAllowed;
                        if (typeof currentValue === 'string') {
                            restrictionData.appInstallationViaPlayStore.minutesAllowed = Number(currentValue);
                        }
                    }
                });
            },
            deep: true
        },
    },
    computed: {
        ...mapWritableState(useUsersStore, {
            users: 'users',
            consolidatedUsersAndSubUsers: 'consolidatedUsersAndSubUsers',
        }),
        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
            currentSelectedConfiguration: 'currentSelectedConfiguration',
            currentSelectedConfigurationIndex: 'currentSelectedConfigurationIndex',
            chosenModel: 'chosenModel',
        }),
        ...mapWritableState(usePhoneTypesStore, {
            phoneTypes: 'phoneTypes',
            appsCommon: 'appsCommon',
            phoneTypeIndex: 'phoneTypeIndex',
        }),
        ...mapWritableState(useConnectionsStore, {
            currentConnection: 'currentConnection',
        }),
        ...mapWritableState(useAppUsageRestrictionsStore, {
            restrictions: 'restrictions',
        }),
        chosenModelAutocompleteErrors() {

            const errors = []
            if (!this.$v.chosenModelAutocomplete.$dirty) return errors
            !this.$v.chosenModelAutocomplete.required && errors.push(this.$gettext('Please select a phone model.'))
            return errors

        },
        userPrivateAttributes() {
            return ['@_internet', '@_categories_profile']
        },
        currentAppInstallationViaPlayStore() {
            if (!this.currentSelectedConfiguration || !this.configurations) return null;

            const currentConfig = this.configurations.find(
                config => config.key === this.currentSelectedConfiguration
            );

            if (!currentConfig?.value?.userInfo?.mdmDeviceId) return null;

            const mdmDeviceId = currentConfig.value.userInfo.mdmDeviceId;
            return this.restrictions[mdmDeviceId]?.appInstallationViaPlayStore || null;
        },
        hasConfigurations() {
            return this.configurations.length > 0
        },
        currentConfigurationHasPhoneModel() {
            return Object.keys(this.configurations[this.currentSelectedConfigurationIndex].value.phone_model).length > 0
        },
        isMinutesAllowedValid() {
            const value = this.currentAppInstallationViaPlayStore?.minutesAllowed;
            
            if (value === null || value === undefined || value === '') {
                return false;
            }
            
            const numValue = Number(value);
            return !isNaN(numValue) && numValue >= 30 && numValue <= 600;
        }
    },
    methods: {

        selectUsersTab() {
            let self = this;

            let homeComponent = self.genericComponentGetComponent('Home')
            homeComponent.currentTab = constants.userTabIndex
            return homeComponent
        },

        selectUsersTabAndGetUsersTabRef() {
            let self = this;
            let homeComponent = self.selectUsersTab()
            return homeComponent.$refs.usersTabRef;
        },

        updateChosenModel(val) {
            this.chosenModel = val;
        },

        updateFolderName(val) {
            this.folderName = val;
        },

        updatePhoneTypeIndex(val) {
            this.phoneTypeIndex = val;
        },

        updateSelectedTemplate(val) {
            this.selectedTemplate = val;
        },

        getConfigurationCountWithFilter() {

            let self = this;

            let totalCount = Object.entries(self.configurations).length;
            let filteredCount = self.configurations.filter((configuration) => self.checkEachConfiguration(configuration.key)).length

            if (totalCount !== filteredCount) {
                return filteredCount + '/' + totalCount
            }

            return totalCount

        },

        clearCurrentSelectedConfiguration() {
            this.currentSelectedConfiguration = ''
        },

        /*installApp(packageId) {

            let self = this;

            let source = self.chosenAppSource === 'common' ?
                self.appsCommon.applications['all applications'] : self.phoneTypes[self.phoneTypeIndex]['value']['applications']['all applications']

            let app = source.filter((application) => {
                return application.packageId.toLowerCase().includes(packageId.toLowerCase())
            })

            if (app?.length > 0) {
                let applications = self.configurations[self.currentSelectedConfigurationIndex].value.applications;
                applications.splice(0, 0, app[0])
                self.removeDuplicatePackageForCurrentConfiguration(app[0].packageId, app[0].appName, 0)
            }

        },*/

        getFilteredCurrentApplications() {

            let self = this

            let filteredApplications = [];

            if (self.currentSelectedConfigurationIndex > -1) {

                filteredApplications = self.configurations[self.currentSelectedConfigurationIndex].value?.applications?.filter((application) => {
                    return application.appName.toLowerCase().includes(self.appFilterText.toLowerCase())
                })
            }

            return filteredApplications;

        },

        removeDuplicatePackagesForAllConfigurations() {

            let self = this
            let foundDuplicates = false
            let foundDuplicatesForInstalledApplications = false

            self.configurations.forEach((configuration, index) => {

                let uniqueApplications = []

                configuration.value?.applications?.forEach((application) => {

                    let appIndex = findIndex(uniqueApplications, uniqueApplication => uniqueApplication.packageId === application.packageId)

                    if (appIndex === -1) {
                        uniqueApplications.push(application)
                    } else {
                        foundDuplicates = true
                    }

                })

                if (uniqueApplications.length) {
                    self.configurations[index].value.applications = uniqueApplications
                } else {
                    self.configurations[index].value.applications = []
                }

                // installed applications now
                let uniqueInstalledApplications = []

                configuration.value['installed_applications'].forEach((application) => {

                    let appIndex = findIndex(uniqueInstalledApplications, uniqueApplication => uniqueApplication.packageId === application.packageId)

                    if (appIndex === -1) {
                        uniqueInstalledApplications.push(application)
                    } else {
                        foundDuplicatesForInstalledApplications = true
                    }

                })

                if (uniqueInstalledApplications.length) {
                    self.configurations[index].value['installed_applications'] = uniqueInstalledApplications
                } else {
                    self.configurations[index].value['installed_applications'] = []
                }

            })

            if (foundDuplicates || foundDuplicatesForInstalledApplications) {
                self.$refs.snackbar.showSnackbar(self.$gettext('We found a few duplicate apps in your configuration and removed them. Please consider persisting this correction by saving. No app information will be lost.'), 'info', 'bottom-end', 6000)
            }

        },

        nullTemplateFields() {
            const self = this
            self.filteredList = null
            self.templateList = null
            self.folderName = null
            self.selectedTemplate = null
        },
        phoneModelChange(val) {

            const self = this
            self.nullTemplateFields()

            /**
             * For chosenDevice
             */
            if (val && !self.chosenModelAutocomplete) {
                self.chosenModel = val;
            } else {
                self.chosenModel = self.chosenModelAutocomplete
            }

            self.folderName = self.getPhoneTypeDirForDevice()
            self.phoneTypeIndex = findIndex(self.phoneTypes, { key: self.chosenModel })

            self.filteredList = self.phoneTypes[self.phoneTypeIndex].value.applications
            self.templateList = Object.keys(self.phoneTypes[self.phoneTypeIndex].value.applications)
            /*?.filter(i => i !== 'xxdisabledxx all applications')*/

            self.templateList = self.templateList.map(templateName => {

                let templateText = templateName, finalTemplateText = ''

                templateText.split(' ').forEach((templateNamePart, index) => {

                    let firstLetterUpperCase = templateNamePart.charAt(0).toUpperCase() + templateNamePart.slice(1)
                    finalTemplateText += !index ? firstLetterUpperCase : ' ' + firstLetterUpperCase

                })

                return {
                    text: finalTemplateText,
                    value: templateName
                }

            })

            self.templateList.push({
                text: 'Empty',
                value: 'empty'
            })

        },
        changeTemplate() {
            const self = this
            if (self.selectedTemplate === 'empty') {
                self.templateAppList = []
            } else {
                self.templateAppList = self.filteredList[self.selectedTemplate]
            }
        },
        updateSelectedUsersForConfiguration() {
            const self = this
            self.manageUsers()
        },
        openAddUserToConfigurationDialog() {
            const self = this
            self.addUserToConfigurationDialog = true
        },
        closeAddUserToConfigurationDialog() {
            const self = this
            self.addUserToConfigurationDialog = false
        },
        insertUserToRule(userKey) {

            const self = this

            if (!self.usersForCurrentConfiguration) {
                self.usersForCurrentConfiguration = []
            }

            if (self.usersForCurrentConfiguration.indexOf(userKey) === -1) {
                self.usersForCurrentConfiguration.push(userKey)
            }

            self.manageUsers()

        },
        deleteUserForRule(user) {
            const self = this
            self.usersForCurrentConfiguration.splice(self.usersForCurrentConfiguration.indexOf(user), 1)
            self.manageUsers()
        },
        manageUsers() {
            const self = this
            const index = findIndex(self.configurations, val => val.key === self.currentSelectedConfiguration)
            self.configurations[index].value.users = self.usersForCurrentConfiguration
            self.syncConfigurations(self.configurations)
        },

        addDeviceToConfiguration() {

            let self = this

            self.$v.$touch()

            if (!self.$v.$invalid) {

                self.configurations[self.currentSelectedConfigurationIndex].value.phone_model = self.chosenModelAutocomplete
                self.$set(self.configurations[self.currentSelectedConfigurationIndex].value, 'applications', self.templateAppList)
                self.chosenModel = self.chosenModelAutocomplete
                self.chosenModelAutocomplete = ''
                self.phoneTypeIndex = findIndex(self.phoneTypes, { key: self.chosenModel })

                self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('%{ model } added successfully for %{configuration}'), {
                    model: self.chosenModel,
                    configuration: self.currentSelectedConfiguration
                }), 'success')

            }

        },

        appBarChanged(val) {

            let self = this

            const chosenPhoneModel = self.configurations[self.currentSelectedConfigurationIndex].value.applications

            if (typeof chosenPhoneModel !== 'undefined' && val.hasOwnProperty('added')) {
                /*const index = findIndex(chosenPhoneModel, (app, index) => (app.packageId === val.added.element.packageId))

                if (index > -1) {
                    self.$set(chosenPhoneModel[index], 'isFavorite', false)
                }*/
            }

            self.removeDuplicatePackageForCurrentConfiguration(val.added?.element?.packageId, val.added?.element?.appName, val.added?.newIndex)

        },

        openAddModelDialog() {

            let self = this

            self.addModelDialog = true
            self.addModelParams = {
                addModelDialog: true,
                allAvailableModels: '',
                currentSelectedConfiguration: self.currentSelectedConfiguration,
                currentSelectedConfigurationIndex: self.currentSelectedConfigurationIndex,
            }

        },
        /*
                correctDroppedApp() {

                    let self = this

                    // let chosenModel = self.configurations[self.currentSelectedConfigurationIndex].value.phone_model[self.chosenModel]

                    let chosenModel = self.configurations[self.currentSelectedConfigurationIndex].value.applications;


                    chosenModel.map(function (app, index) {

                        if (Array.isArray(app)) {

                            chosenModel[index] = {
                                packageId: app.packageId,
                                appName: app.appName,
                                isFavorite: app.isFavorite ? app.isFavorite : false
                            }

                        }

                    })


                },*/

        deleteConfiguration(configurationName) {

            let self = this

            const configurationIndex = findIndex(self.configurations, function (o) {
                return o.key === configurationName
            })

            const selectNewConfiguration = () => {
                if (self.configurations.length > 0) {
                    if (self.configurations[configurationIndex]) {
                        // get the configuration after the deleted one
                        self.selectConfiguration(self.configurations[configurationIndex].key);
                    } else {
                        // select the first one
                        self.selectConfiguration(self.configurations[0].key);
                    }
                } else {
                    // reset the selected configuration
                    self.currentSelectedConfiguration = '';
                    self.currentSelectedConfigurationIndex = -1;
                }
            }

            const deleteConfiguration = function () {

                if (configurationIndex > -1) {
                    self.configurations.splice(configurationIndex, 1)
                }

                selectNewConfiguration();

            }

            const swalOptions = {
                title: self.$gettext('Delete Configuration'),
                description: self.$gettextInterpolate(self.$gettext('Are you sure you want to delete %{ configurationName } configuration?'), { configurationName: configurationName }),
                successCallback: deleteConfiguration,
                confirmButtonText: self.$gettext('Delete it!'),
                icon: 'warning',
                successText: self.$gettextInterpolate(self.$gettext('Configuration %{ configurationName } deleted successfully!'), { configurationName: configurationName }),
            }

            self.swalConfirmation(swalOptions)

            // select configuration again, otherwise the active state of the v-list is lost
            self.selectConfiguration(configurationName)

        },

        /**
         * @param configurationName
         */
        selectConfiguration(configurationName) {

            let self = this
            self.currentSelectedConfiguration = configurationName

            // The v-list-item-group's model gets reset to empty when click twice, as it toggles the value. Since we do not wish to toggle the value, we set it manually back again with the $nextTick where setTimeout is a safety net. We have this similar code block for ProfileApplicationTab and GroupsTab

            self.$nextTick(() => {
                self.currentSelectedConfiguration = configurationName
            })

            setTimeout(() => {
                self.currentSelectedConfiguration = configurationName
            }, 300)

            /**
             * A workaround for: https://github.com/vuetifyjs/vuetify/issues/4733
             */
            window.dispatchEvent(new Event("resize"));
        },

        /**
         * If we do not do this, when a drag and drop is to occur the changes are not pushed to store and hence not saved.
         * This helps.
         */
        syncConfigurations() {

            let self = this

            const phonesStore = usePhonesStore()
            self.$nextTick(() => phonesStore.setConfigurations(self.configurations))

        },

        checkEachConfiguration(configurationName) {

            let self = this
            let configurationVisibility = true

            if (self.configurationFilterValue && self.configurationFilterValue.length > 0) {
                configurationVisibility = configurationName && configurationName?.toLowerCase().includes(self.configurationFilterValue.toLowerCase());
            }

            if (configurationVisibility) {
                // this area is left for further filter, not required now but a placeholder
            }

            return configurationVisibility

        },

        configurationSelectedForMobile() {
            let self = this

            // extra lines to increase readability.
            return (
                self.$vuetify.breakpoint.smAndUp

                ||

                (
                    self.$vuetify.breakpoint.mobile &&
                    (
                        self.currentSelectedConfiguration === '' || self.currentSelectedConfiguration === false || self.currentSelectedConfiguration.length === 0
                    )
                )
            )
        },

        /**
         * This considers search parameter/filter as well
         * @returns {boolean}
         */
        currentViewConfigurationCount() {

            let self = this
            let configurationCount = 0

            if (self.configurations && Object.keys(self.configurations).length > 0) {

                for (let key in self.configurations) {
                    self.checkEachConfiguration(self.configurations[key]['key']) ? configurationCount++ : ''
                }

            }

            return configurationCount
        },

        /**
         *
         * TODO: Make a mixin of the method
         *
         * Not that it is significant but know that this is being called twice by AppIcon
         * @param val
         * @param packageName
         */
        updateShowMenu(val, packageName) {

            let self = this

            // TODO: This if is no help, remove it.
            if (val.packageName === packageName) {

                self.$set(this.showMenu, 'value', val.value)
                self.$set(this.showMenu, 'packageName', val.packageName)

                self.x = val.x
                self.y = val.y

            }

        },

        /**
         * Not in use as of now
         * @returns {Promise<void>}
         */
        /*async loadPageInformation () {

            let self = this

            try {

                const getApplicationResponse = await self.profileApplicationTabGetApplication()

                if (getApplicationResponse?.data?.status) {
                    self.applicationTabField = getApplicationResponse.data.data.application.field
                } else {
                    self.$refs.snackbar.showSnackbar(self.$gettext('Sorry! the application information could not be loaded.'), 'error')
                }

            } catch (e) {
                console.log(e)
            }

        },*/


        /*openAddEditAppDialog(app) {

            let self = this
            let appIndex = self.appsGetIndex(self.currentSelectedConfigurationIndex, app.packageId)

            self.addEditAppParams = {
                addEditAppDialog: true,
                app,
                appIndex,
                chosenModel: this.chosenModel,
                currentSelectedConfiguration: self.currentSelectedConfiguration,
                currentSelectedConfigurationIndex: self.currentSelectedConfigurationIndex,
            }

            self.addEditAppDialog = true

        },*/
        openAddEditConfigurationDialog(mode = 'add', currentSelectedConfigurationKey = false, currentSelectedConfiguration = false) {

            let self = this

            const editLinkedDevice = () => {

                let currentSelectedConfigurationValue = self.configurations[self.currentSelectedConfigurationIndex]['value'];
                let userGroup = currentSelectedConfigurationValue['user_group'];
                let user = currentSelectedConfigurationValue['user'];
                let deviceName = currentSelectedConfigurationValue['device'];

                let userComponent = self.selectUsersTabAndGetUsersTabRef();
                userComponent.openUserGroupAndUserPanel(userGroup, user)

                let deviceObj = userComponent.getDeviceByName(user, deviceName)
                userComponent.openAddEditDeviceMobileDialog(userGroup, user, 'edit', deviceName, deviceObj.active)

            }

            self.$refs.snackbar.showSnackbar(self.$gettext("Please edit the associated device to update this configuration name"), 'info', 'bottom-end', 10000, {
                callback: editLinkedDevice,
                confirmButtonText: self.$gettext('Edit Linked Device'),
            });

            /*---------------------------------------------
                Do not delete this
            ----------------------------------------------*/

            /*self.addEditConfigurationParams = {
                addEditConfigurationDialog: true,
                mode,
                inEditConfigurationName: currentSelectedConfigurationKey,
                currentSelectedConfiguration: self.currentSelectedConfiguration,
            }

            self.addEditConfigurationDialog = true

            // The click to openAddEditConfigurationDialog makes the focus lose. Because of the toggle nature of the v-list-item-group. So we set it back again here with the $nextTick
            self.$nextTick(() => {
                if (currentSelectedConfigurationKey) {
                    self.currentSelectedConfiguration = currentSelectedConfigurationKey
                }
            })

            self.nullTemplateFields()*/

            // We are doing this because otherwise the configuration selection is lost.
            self.$nextTick(() => {
                self.currentSelectedConfiguration = currentSelectedConfigurationKey
            })

        },

        openAddEditDeviceMobileDialogV2(mode, configuration = false, currentSelectedConfiguration, currentSelectedConfigurationIndex) {

            let self = this

            self.addEditDeviceMobileDialog = true
            self.setFieldsForAddEditDeviceDialog(mode, configuration)
            self.refreshParamsForAddEditDeviceMobileDialog()

            return false

        },

        /**
         *
         * This is currently common between mobile and computer devices.
         *
         * @param configuration
         * @param mode
         */
        setFieldsForAddEditDeviceDialog(mode, configuration) {

            let self = this

            self.editDeviceNameField = configuration?.key
            self.editDeviceCredentialsField = configuration?.value?.credentials
            self.addEditDeviceMode = mode
            self.editPhoneModel = configuration?.value?.phone_model

        },

        /**
         * When dependencies are updated, this should be updated but it isn't.
         * Doing it manually for now.
         */
        refreshParamsForAddEditDeviceMobileDialog() {

            let self = this

            self.addEditDeviceMobileDialogParams = {
                editDeviceMobileDialog: self.addEditDeviceMobileDialog,
                deviceName: self.editDeviceNameField,
                deviceCredentials: self.editDeviceCredentialsField,
                mode: self.addEditDeviceMode,
                phoneModel: self.editPhoneModel,
            }

        },

        handleMobileDeviceUpdate({ categoryParent, userParent, previousDeviceName, newDeviceName, value }) {
            // this.populateRight();
        },

        handleMobileDeviceAddV2({ categoryParent, userParent, deviceName, value, configurationName }) {
            // this.populateRight();
        },

        async refreshAppStore() {
            let self = this;

            if (!self.currentSelectedConfiguration) {
                self.$refs.snackbar?.showSnackbar(self.$gettext('No configuration selected.'), 'error');
                return;
            }

            // Get the account from the selected configuration's userInfo.login (email) or mdmDeviceId as per your folder structure
            const account = self.configurations[self.currentSelectedConfigurationIndex]?.value?.userInfo?.login;
            if (!account) {
                self.$refs.snackbar?.showSnackbar(self.$gettext('Account (login) not found in configuration.'), 'error');
                return;
            }

            self.$refs.snackbar?.showSnackbar(self.$gettext('Refreshing App Store...'), 'info');
            try {
                // If you have a base URL helper, use it here. Otherwise, use a relative path.
                // Example: const url = `${this.apiBaseUrl}/get_app_store.php`;
                const url = '/get_app_store.php';
                const params = {
                    accountName: account,
                    configuration_key: self.currentSelectedConfiguration
                };
                const response = await axios.get(url, { params });
                const data = response.data;
                if (data.status && Array.isArray(data.installed_applications)) {
                    // Update only installed_applications for the selected configuration
                    const idx = self.currentSelectedConfigurationIndex;
                    if (idx !== -1 && self.configurations[idx]) {
                        self.$set(self.configurations[idx].value, 'installed_applications', data.installed_applications);
                        eventBus.$emit('refresh-app-store'); // otherwise the new apps are not visible in the app store
                        self.$refs.snackbar?.showSnackbar(self.$gettext('App Store refreshed.'), 'success');
                    } else {
                        self.$refs.snackbar?.showSnackbar(self.$gettext('Configuration not found in store.'), 'error');
                    }
                } else {
                    self.$refs.snackbar?.showSnackbar(data.error || self.$gettext('Failed to refresh App Store.'), 'error');
                }
            } catch (e) {
                // Optionally log the error for debugging
                console.error('Error refreshing App Store:', e);
                self.$refs.snackbar?.showSnackbar(self.$gettext('Error refreshing App Store.'), 'error');
            }
        },

        setShowAllowAppInstallationsOptions(value) {
            this.showAllowAppInstallationsOptions = value;
        },

        deleteAppInstallationViaPlayStore() {
            if (!this.currentSelectedConfiguration || !this.configurations) return;

            const currentConfig = this.configurations.find(
                config => config.key === this.currentSelectedConfiguration
            );

            if (!currentConfig?.value?.userInfo?.mdmDeviceId) return;

            const mdmDeviceId = currentConfig.value.userInfo.mdmDeviceId;
            const appUsageRestrictionsStore = useAppUsageRestrictionsStore();
            appUsageRestrictionsStore.deleteAppInstallationViaPlayStoreForDevice(mdmDeviceId);
            this.showAllowAppInstallationsOptions = false;
        },

        setBlankAppInstallationViaPlayStore() {
            if (!this.currentSelectedConfiguration || !this.configurations) return;

            const currentConfig = this.configurations.find(
                config => config.key === this.currentSelectedConfiguration
            );

            if (!currentConfig?.value?.userInfo?.mdmDeviceId) return;

            const mdmDeviceId = currentConfig.value.userInfo.mdmDeviceId;
            const appUsageRestrictionsStore = useAppUsageRestrictionsStore();
            appUsageRestrictionsStore.setAppInstallationViaPlayStoreForDevice(mdmDeviceId, {
                minutesAllowed: 30,
                createdAt: new Date().toISOString(),
            });
            this.showAllowAppInstallationsOptions = true;
        },

    },
    validations: {
        chosenModelAutocomplete: {
            required,
        },
    }
}

</script>
<style type="text/scss">
/*==========  Mobile First Method  ==========*/

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {

    .border-right-divider {
        border-right: 1px solid #e0e0e0;
    }


    .row.template_row {
        display: flex;
        flex-direction: column;
        align-self: baseline;
    }

}

/* Refresh Apps Button Styling */
.refresh-apps-btn {
    font-weight: 600 !important;
    text-transform: none !important;
    border-radius: 8px !important;
    min-height: 40px !important;
    padding: 0 16px !important;
}

.refresh-apps-btn .v-icon {
    margin-right: 8px !important;
}

/* Extra Small Devices, Phones */
/*
@media only screen and (min-width: 480px) {
    .smartphone-width {
        width: 360px;
    }

    !* The screen (or content) of the device *!
    .smartphone .smartphone-content {
        width: 328px;
        background: white;
    }
}
*/

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {}

.hover-underline:hover {
    border-bottom: 1px dotted #004E7C;
    cursor: pointer;
    padding-bottom: 2px;
    transition: border-bottom 0.2s;
}

.max-width-200 {
    max-width: 200px;
}
</style>
